import { NavLink } from 'react-router-dom'
import {
  Box,
  VStack,
  Link,
  Icon,
} from '@chakra-ui/react'
import {
  FiHome,
  FiList,
  FiUsers,
  FiSettings,
  FiHome as FiBuilding,
  FiLayers,
  FiUserCheck,
  FiTag,
} from 'react-icons/fi'

const navItems = [
  { to: '/', label: '首頁', icon: FiHome },
  { to: '/workflows', label: '工作流程', icon: FiList },
  { to: '/workflow-types', label: '流程類型', icon: FiTag },
  { to: '/operators', label: '操作人員', icon: FiUserCheck },
  { to: '/sampling', label: '採樣設定', icon: FiLayers },
  { to: '/customers', label: '客戶/單位', icon: FiBuilding },
  { to: '/users', label: '用戶管理', icon: FiUsers },
  { to: '/settings', label: '系統設定', icon: FiSettings },
]

export default function Navigation() {
  return (
    <Box w="250px" bg="gray.50" minH="calc(100vh - 60px)" p={4}>
      <VStack spacing={2} align="stretch">
        {navItems.map((item) => (
          <Link
            key={item.to}
            as={NavLink}
            to={item.to}
            px={3}
            py={2}
            rounded="md"
            display="flex"
            alignItems="center"
            _hover={{ bg: 'gray.100' }}
            _activeLink={{
              bg: 'brand.500',
              color: 'white',
            }}
          >
            <Icon as={item.icon} mr={3} />
            {item.label}
          </Link>
        ))}
      </VStack>
    </Box>
  )
}